export default __webpack_public_path__ + "static/media/sellout-logo-mono-white.8cb6c0dc.svg";